import React from 'react'
import { Button } from 'antd';
import { useIntl } from "react-intl";

const TransferButton = ({isDisabled, isDetectedTT, hanleClick}) => {
    const intl = useIntl();
    const detectText = intl.formatMessage({id:"Detecting",defaultMessage:"Detecting"});
    const transferText = intl.formatMessage({id:"Start transfer",defaultMessage:"Start transfer"});
    return (
        <Button 
            className="transferBtn" 
            disabled={isDisabled || !isDetectedTT}
            onClick={hanleClick}
            type='primary'
        >
            <span>
                {!isDetectedTT
                    ? detectText+'...'
                    : transferText
                }
            </span>
        </Button> 
    )
}

export default TransferButton;
